// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1sBhx","boxTitle":"Qualiphy_boxTitle__3PdGH","box":"Qualiphy_box__H5tEz","toggleWrap":"Qualiphy_toggleWrap__1KHjz"};